function Header() {
  return (
    <header className='app-header'>
      <img src='logo512.png' alt='EcoCarto Logo' style={{marginRight:'20px'}} />
      <h1>The Fracking Water Quiz</h1>
    </header>
  );
}

export default Header;
